<template>
    <v-row dense>
        <v-col cols="2">
            <v-text-field 
                v-model="post_title"
                dense
                class="mt-3"
            ></v-text-field>
        </v-col>
        <v-col cols="4">
            <v-text-field 
                v-model="post_content"
                dense
                class="mt-3"
            >
            </v-text-field>
        </v-col>
        <v-col cols="5">
            <v-select
                v-model="selected_rooms"
                :items="selectable_rooms"
                item-text="post_title"
                item-value="ID"
                multiple
                dense
            ></v-select>
        </v-col>
        <v-col class="pt-4">
            <v-btn v-if="isDirty" icon color="success" small @click="saveWebhook()" :loading="saving" :disabled="saving">
                <v-icon small>mdi-check</v-icon>
            </v-btn>
            <v-btn v-if="isDirty" icon color="error" small @click="resetValues()" :disabled="saving">
                <v-icon small>mdi-close</v-icon>
            </v-btn>
            <v-btn v-else-if="post_content" icon small @click="sendTest()" :disabled="saving" title="Send Test">
                <v-icon small>mdi-refresh</v-icon>
            </v-btn>
            <v-dialog
                v-if="!isDirty"
                v-model="confirm_delete_webhook"
                width="500"
                overlay-opacity="0.9"
            >
                <template v-slot:activator="{ on, attrs }">
                    <v-btn
                    v-bind="attrs"
                    v-on="on"
                    icon
                    small
                    >
                        <v-icon small>mdi-delete</v-icon>
                    </v-btn>
                </template>

                <v-card>
                    <v-card-title class="text-h5">
                    Delete webhook?
                    </v-card-title>

                    <v-card-text>
                    Are you sure you want to delete this webhook?
                    </v-card-text>

                    <v-divider></v-divider>

                    <v-card-actions>
                    <v-spacer></v-spacer>
                    <v-btn text @click="confirm_delete_webhook = false">Cancel</v-btn>
                    <v-btn
                        color="error"
                        text
                        @click="deleteWebhook"
                    >
                        Delete
                    </v-btn>
                    </v-card-actions>
                </v-card>
            </v-dialog>
        </v-col>
    </v-row>
</template>

<script>
import { useUserStore } from '../../stores/user'
// import { useAppStore } from '../../stores/app'
import { useRoomsStore } from '../../stores/rooms'

export default {
    name: 'Webhook',
    props: ["webhook"],
    created: function() {
        this.user = useUserStore()
        this.rooms = useRoomsStore()
        // this.rooms.loadRooms()
        // this.app = useAppStore()
    },
    data: function() {
        return {
            user: null,
            // app: null,
            rooms: [],
            selected_rooms: [],
            // webhooks: [
            //     {ID: 1, post_title:'My Webhook', post_content:'https://somewhere.com'}
            // ],
            // webhook: [],
            loading: false,
            saving: false,
            deleting: false,
            integrations: [],
            headers: [    
                {
                    text: 'Integration',
                    align: 'start',
                    sortable: true,
                    value: 'locationId',
                },
                {
                    text: '',
                    value: 'actions',
                    align: 'right',
                    sortable: false
                }
            ],
            show_confirm_delete_dialog: false,
            delete_integration: { location: { name: '' } },
            show_connect_room_dialog: false,
            selected_room: 0,
            connecting_integration: null,
            connecting_room: false,
            ID: 0,
            post_title: '',
            post_content: '',
            post_meta: {},
            confirm_delete_webhook: false,
            editing: false,
            orig_post_title: '',
            orig_post_content: '',
            orig_selected_rooms: [],
        }
    },
    mounted: function() {
        this.ID = this.webhook.ID
        this.post_title = this.webhook.post_title
        this.post_content = this.webhook.post_content
        this.selected_rooms = this.webhook.selected_rooms.sort((a, b) => a - b)
        // this.selectable_rooms = [{ID: -1, post_title: 'All'}, this.rooms.rooms]

        this.syncValues()
    },
    computed: {
        isDirty() {
            return this.post_title != this.orig_post_title 
                || this.post_content != this.orig_post_content
                || !this.arraysContainSameValues(this.selected_rooms, this.orig_selected_rooms)
        },
        selectable_rooms() {
            return [{ID: -1, post_title: 'All'}, ...this.rooms.rooms]
            // return this.rooms.rooms.unshift({ID: -1, post_title: 'All'})
        }
    },
    methods: {
        saveWebhook() {
            this.saving = true
            this.user.app.post('meeting/webhooks', {
                ID: this.ID,
                post_title: this.post_title, 
                post_content: this.post_content,
                selected_rooms: this.selected_rooms
            })
            .then(response => {
                this.user.app.showSuccess('Webhook Saved')
                this.user.app.webhooks = response.data.webhooks
                this.syncValues()
            })
            .catch((e) => {
                console.error(e)
                this.user.app.showError('An error occurred while saving your webhook.')
            })
            .finally(() => {
                this.saving = false
                this.editing = false
            })
        },
        deleteWebhook() {
            let g = this
            this.deleting = true
            this.user.app.delete('meeting/webhooks/'+this.ID)
            .then(response => this.user.app.webhooks = response.data.webhooks)
            .finally(() => {
                // this.app.getWebhooks()
                this.deleting = false
                this.editing = false
            })
        },
        arraysContainSameValues(arr1, arr2) {
            if(!Array.isArray(arr1) || !Array.isArray(arr2))
                return
            // Check if the arrays have the same length
            if (arr1.length !== arr2.length) {
                return false;
            }

            // Sort the arrays
            const sortedArr1 = arr1.slice().sort();
            const sortedArr2 = arr2.slice().sort();

            // Compare the sorted arrays element by element
            for (let i = 0; i < sortedArr1.length; i++) {
                if (sortedArr1[i] !== sortedArr2[i]) {
                return false;
                }
            }

            return true;
        },
        resetValues() {
            this.post_title = this.orig_post_title
            this.post_content = this.orig_post_content
            this.selected_rooms = this.orig_selected_rooms
        },
        syncValues() {
            console.log('syncValues')
            //save original values
            this.orig_post_title = this.post_title
            this.orig_post_content = this.post_content
            this.orig_selected_rooms = this.selected_rooms
        },
        sendTest() {
            console.log('sendTest', this.post_content)
            this.saving = true
            this.user.app.post('meeting/webhooks/test', {
                url: this.post_content
            })
            .then(response => {
                this.user.app.showSuccess('Webhook Test Complete')
            })
            .catch((e) => {
                console.error(e)
                this.user.app.showError('An error occurred while testing the webhook.')
            })
            .finally(() => {
                this.saving = false
                // this.editing = false
            })

        }
    },
    watch: {
        // ID(newV, oldV) {
        //     if(newV > 0 && !!newV) {
        //         this.orig_post_title = this.post_title
        //         this.orig_post_content = this.post_content
        //     }

        // }
        // post_title(newV, oldV) {
        //     if(!oldV)
        //         return
        //     this.editing = true
        // },
        // post_content(newV, oldV) {
        //     if(!oldV)
        //         return
        //     this.editing = true
        // },
        // selected_rooms(newV, oldV) {
        //     if(!oldV.length)
        //         return
        //     this.editing = true
        // }
    }

}
</script>